import React, { Fragment, useEffect } from 'react'
import { useAuth } from "hooks/use-auth";
import { useForm, SubmitHandler } from "react-hook-form";
import config from 'config';
import { FormLabel, FormInput, FormLabelInputWrapper, ModalSubmit, Title, DeleteUserButton, DivFlex } from 'styles/styles';

interface CognitoMailDataProps {
	email: string
}

export const CognitoSetMail = () => {
	const auth = useAuth();
	useEffect(() => {
		setValue('email', auth.email);
	}, [auth]);

	const [newEmail, setNewEmail] = React.useState('');

	//modal
	const { reset, register, handleSubmit, watch, setValue, formState: { errors } } = useForm<CognitoMailDataProps>();
	const onSubmit: SubmitHandler<CognitoMailDataProps> = async (submitData: CognitoMailDataProps) => {
		if (submitData.email === auth.email) {
			window.alert("現在登録されているメールアドレスと別のアドレスを入力してください。");
			return;
		}
		const res = await auth.updateEmail(submitData.email);
		setNewEmail(submitData.email);
		window.alert(res.message);
	}
	//modal end

	//arrayの生成
	const parentArray = [
		{ title: 'ログインメールアドレス', field: 'email', type: 'email', required: true }]

	const listItems = parentArray.map((element: any, index) => {
		if (element.title) {
			return (
				<Fragment key={index}>
					<FormLabelInputWrapper>
						<FormLabel htmlFor={element.field}>{element.title}</FormLabel>
						<FormInput {...register(element.field)}
							{...(element.type && { type: config.inputErrorMessage[element.type].type })}
							{...(element.type && { placeholder: config.inputErrorMessage[element.type].placeholder })}
							{...(element.type && { pattern: config.inputErrorMessage[element.type].pattern })}
							{...(element.type && { title: config.inputErrorMessage[element.type].title })}
							{...(element.required && { required: true })}
							{...(element.disable && { disabled: true })}
							{...(element.type && { maxLength: config.inputErrorMessage[element.type].maxLength })}
							{...(element.type === "number" && { max: config.inputErrorMessage[element.type].max })}
						/>
					</FormLabelInputWrapper>
				</Fragment>
			)
		}
	});

	if (auth.waitingForEmailAttributeVerificationCodeInput) {
		return <EmailConfirmForm mail={newEmail} />;
	}

	return (
		<>
			<form onSubmit={handleSubmit(onSubmit)}>
				{listItems}
				<ModalSubmit type="submit" value={"変更する"} />
			</form>
		</>
	)
}

const EmailConfirmForm = ({ mail }: { mail: string }) => {
	interface Inputs {
		verificationCode: string,
	};

	const auth = useAuth();
	const { register, handleSubmit, watch, formState: { errors } } = useForm<Inputs>();

	const onSubmit: SubmitHandler<Inputs> = async data => {
		const res = await auth.confirmEmailAttributeSubmit(data.verificationCode);
		window.alert(res.message);
	};

	const cancelSubmit = async () => {
		const res: any = auth.cancelEmail();
		window.alert(res.message);
	}

	return (
		<>
			<form onSubmit={handleSubmit(onSubmit)}>
				<Title>メール認証コード入力</Title>
				<DivFlex><strong>{mail}</strong>に認証コードを送信しました。<DeleteUserButton onClick={cancelSubmit}>キャンセル</DeleteUserButton></DivFlex>
				<FormLabelInputWrapper>
					<FormLabel htmlFor="verificationCode">メール認証コード:</FormLabel>
					<FormInput {...register("verificationCode")} type="verificationCode" id="verificationCode" name="verificationCode" required
						onKeyDown={(e) => {
							if (e.key === "Enter") {
								e.preventDefault();
							}
						}} />
				</FormLabelInputWrapper>
				<ModalSubmit type="submit" />
			</form>
		</>
	)
}